export { default } from './OutlookCard.jsx';
